/*
 *
 * @desc: App - H5 相关配置
 * @author: haifn
 * @time: 2019-06-03 18:38
 *
 */

export const IOS_APP_CONFIG = {
  'insta_app_name': {
    oner: 'oner',
    go: 'go',
    onex: 'onex',
    one: 'one',
    nanos: 'nanos',
    nano: 'nano',
    panoclip: 'panoclip',
    evo: 'evo',
    moment: 'moment',
  },
  'url_schemes': {
    onex: 'com.insta360.onex://',
    one: 'com.insta360.one://',
    nanos: 'com.insta360.nanos://',
    nano: 'com.insta360.nano://',
    panoclip: 'com.insta360.lite://',
    evo: 'com.insta360.evo://',
    monent: 'com.insta360.reader://',
  },
};

export const ANDROID_APP_CONFIG = {
  'insta_app_name': {
    oner_android: 'oner_android',
    go_android: 'go_android',
    onex_android: 'onex_android',
    one_android: 'one_android',
    evo_android: 'evo_android',
    moment_android: 'moment_android',
  },
};
